<div class="breadcrumbs-bottom">
  <div class="flex">
    <mat-icon class="pin"> pin_drop_outlined </mat-icon>
    <span>
      {{ "breadcrumbs.youAreAt" | translate }} {{ breadcrumbsData.title | translate: { param: breadcrumbsData.param } }}
    </span>
  </div>
  <div class="buttons">
    @for(action of breadcrumbsData.buttons; track action){
    <button
            [ngClass]="action.hide ? 'hide' : (action.style ? action.style : '')" mat-flat-button
            [routerLink]="action.router"
            [disabled]="action.disabled ? action.disabled : false"
            (click)="action.do ? action.do!() : null"
    >
    @if(action.icon){
      <mat-icon>
        {{action.icon}}
      </mat-icon>
    }
      {{ action.label | translate }}
    </button>
  }
  </div>
</div>

